import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "../../ui/alert.tsx";
import { Button } from "../../ui/button.tsx";

export default function Error({ error, refetch }: { error: Error, refetch: () => void }) {
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        Failed to load status: {error.message}
        <Button variant="outline" size="sm" onClick={() => refetch()} className="ml-2">
          Retry
        </Button>
      </AlertDescription>
    </Alert>
  )
}